import { createStore } from 'redux';
import rootReducer from '../reducers';
import { loadState } from './localstorage'

const persistedState = loadState();
const stores = createStore(rootReducer, persistedState)

export default stores ; 